import { Component, Input, ViewChild } from '@angular/core';
import { CoreConfigService } from 'src/@core/services/config.service';
import { employee } from 'src/app/modules/app/_reports/interfaces';

@Component({
  selector: 'app-dashboard-team-card',
  templateUrl: './dashboard-team-card.component.html',
  styleUrls: ['./dashboard-team-card.component.scss'],
})
export class DashboardTeamCardComponent {
  @Input('cardTitle') title: string = '';
  @Input('redirectTo') url: string = '';
  @Input('totalCount') totalCount: number = 0;
  @Input('counts') counts: Array<{
    title: string;
    count: number;
    team?: employee[];
    text?: string[];
  }> = [];

  @ViewChild('chartRef') chartRef: any;

  protected chartOptions1: any;

  private $primary = '#7367F0';
  private $warning = '#FF9F43';
  private $info = '#00cfe8';
  private $info_light = '#1edec5';
  private $strok_color = '#b9c3cd';
  private $label_color = '#e7eef7';
  private $white = '#fff';
  private $textHeadingColor = '#5e5873';
  colors = {
    solid: {
      primary: '#7367F0',
      secondary: '#82868b',
      success: '#28C76F',
      info: '#00cfe8',
      warning: '#FF9F43',
      danger: '#EA5455',
      dark: '#4b4b4b',
      black: '#000',
      white: '#fff',
      body: '#f8f8f8',
    },
    light: {
      primary: '#7367F01a',
      secondary: '#82868b1a',
      success: '#28C76F1a',
      info: '#00cfe81a',
      warning: '#FF9F431a',
      danger: '#EA54551a',
      dark: '#4b4b4b1a',
    },
  };
  public isMenuToggled = true;
  constructor(private _coreConfigService: CoreConfigService) {
    this.chartOptions1 = {
      series: [
        {
          name: 'My-series',
          data: [],
        },
      ],
      chart: {
        height: 350,
        width: 0,
        type: 'bar',
      },
      title: {
        text: 'My First Angular Chart',
      },
      colors: [],
      xaxis: {
        categories: [
          // 'Jan',
          // 'Feb',
          // 'Mar',
          // 'Apr',
          // 'May',
          // 'Jun',
          // 'Jul',
          // 'Aug',
          // 'Sep',
        ],
      },
    };
  }
  ngAfterViewInit() {
    // Subscribe to core config changes
    this._coreConfigService.getConfig().subscribe((config) => {
      // If Menu Collapsed Changes
      if (
        config.layout.menu.collapsed === true ||
        config.layout.menu.collapsed === false
      ) {
        setTimeout(() => {
          // Get Dynamic Width for Charts
          this.isMenuToggled = false;
          if (this.chartOptions1.chart) {
            this.chartOptions1.chart.width =
              this.chartRef?.nativeElement.offsetWidth;
          }
        }, 1000);
      }
    });

    // // this.chartOptions1.labels.push(this.title);
    this.chartOptions1.series[0].name = this.title;
    this.chartOptions1.title.text = this.title;
    if (this.title == 'Projects') {
      this.chartOptions1.colors.push(this.colors.solid.primary);
    }
    if (this.title == 'Customer') {
      this.chartOptions1.colors.push(this.colors.solid.info);
    }
    if (this.title == 'Team') {
      this.chartOptions1.colors.push(this.colors.solid.success);
    }
    if (this.title == 'Tickets') {
      this.chartOptions1.colors.push(this.colors.solid.secondary);
    }
    this.counts.forEach((x) => {
      if (x.title.toLowerCase() != 'Average Time'.toLowerCase()) {
        this.chartOptions1.xaxis.categories.push(x.title);
        this.chartOptions1.series[0].data.push(x.count);
      }
    });
  }
}
